import axios from 'axios';
import storageService from './storage.service';

class TokenRefreshService {
  private refreshPromise: Promise<string> | null = null;

  public refresh = (): Promise<string> => {
    if (this.refreshPromise) return this.refreshPromise;

    const session = storageService.getObject('session') || {};
    const token = session.access_token || '';

    this.refreshPromise = axios
      .get(`${process.env.REACT_APP_API_URL}/auth/refresh-token`, { params: { token } })
      .then(({ data }) => {
        const newToken = data?.data?.access_token;
        if (!newToken) throw new Error('refresh-token: token ausente na resposta');

        const localSession = storageService.getObject('session') || {};
        localSession.access_token = newToken;
        storageService.setObject('session', localSession);

        return newToken;
      })
      .finally(() => {
        this.refreshPromise = null;
      });

    return this.refreshPromise;
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new TokenRefreshService();
